import { render, staticRenderFns } from "./pbi-sales-registration-effectiveness.page.vue?vue&type=template&id=506d09f8"
import script from "./pbi-sales-registration-effectiveness.page.vue?vue&type=script&lang=ts"
export * from "./pbi-sales-registration-effectiveness.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports